import React from "react";
import { throttle } from "throttle-debounce";

const createScrollAction = fn => {
  let lastVal = 0;
  return throttle(300, perc => {
    if (perc !== lastVal && perc > lastVal && perc >= 0.95) {
      fn();
    }
    lastVal = perc;
  });
};

export default createScrollAction;
